import { Checkbox, Space, Button } from 'antd';
import { useContext, useMemo } from 'react';
import { SpuSelectContext } from './context';
import { useTranslate } from '@tolgee/react';

const StatusBar = (props: {
  selectedSkuLen: number;
  currentPageSpuIds: string[];
  onRemove: () => void;
  empty: boolean;
}) => {
  const { t } = useTranslate();
  const { selectedSkuLen, currentPageSpuIds, onRemove, empty } = props;
  const { spuSelectMap, getBatchStatus, toggleBatch, cancelSelect } = useContext(SpuSelectContext);
  const { checked, indeterminate } = useMemo(() => {
    return getBatchStatus!(currentPageSpuIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spuSelectMap, currentPageSpuIds]);

  return (
    <div className="flex items-center">
      <Space size={12}>
        {!empty && (
          <Checkbox
            checked={checked}
            indeterminate={indeterminate}
            onChange={(e) => {
              toggleBatch!(currentPageSpuIds, e.target.checked);
            }}
          >
            {t('voucher.本页全选')}
          </Checkbox>
        )}
        {selectedSkuLen > 0 && (
          <>
            <div>{t('voucher.已选x', { x: selectedSkuLen })} SKU</div>
            <Button className="!px-0 !py-0" type="link" onClick={() => cancelSelect!()}>
              {t('single_cancel_select')}
            </Button>
            <Button className="!px-0 !py-0" type="link" onClick={() => onRemove()}>
              {t('single_remove')}
            </Button>
          </>
        )}
      </Space>
    </div>
  );
};

export default StatusBar;
